export const PROCEED_EVENT_NAME = 'proceed'
export const LOAD_EVENT_NAME = 'load'
